import React from 'react';

const SpeedVisual = ( props: any ) => {
  const path = 'M 50 400 A 50 52.5 0 0 1 750 400';
  const { product, supplementalData } = props;
  const { handle, graph } = supplementalData[product].speedVisuals || {};

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 800 435"
      className="speed_visual"
      style={ { '--handle': handle, '--offset': graph } }
      {...props}
    >
      <defs>
        <style>
        {`
          .speed_visual {
            margin-left: -16px;
            margin-right: -16px;
          }

          .speed_visual path {
            fill: none;
            stroke-width: 30px;
          }

          .speed_bkgd {
            stroke: var(--color-primary);
            opacity: 0.25;
          }

          .speed_bkgd,
          .speed_mask {
            stroke-dasharray: 375, 15, 168, 15, 168, 15, 168, 15, 168;
          }

          .speed_graph {
            stroke: var(--color-primary);
            stroke-dasharray: 1100;
            stroke-dashoffset: 1100;
            animation: maskOffset 2s 0.5s forwards linear paused;
          }

          .speed_handle {
            fill: var(--color-white);
            stroke-width: 10px;
            stroke: var(--color-primary);
            animation: handleOffset 2s 0.5s forwards linear paused;
          }

          .speed_graph,
          .speed_handle {
            animation-play-state: running;
          }

          @keyframes maskOffset {
            to { stroke-dashoffset: var(--offset); }
          }

          @keyframes handleOffset {
            to { offset-distance: var(--handle); }
          }
        `}
        </style>
      </defs>
      <mask id="mask-path">
        <path className="speed_mask" d={ path } stroke="white"></path>
      </mask>
      <path className="speed_bkgd" d={ path } stroke={ props?.stroke }></path>
      <g mask="url(#mask-path)">
        <path className="speed_graph" d={ path } stroke={ props?.stroke }></path>
      </g>
      <circle
        cx="0"
        cy="0"
        r="24"
        fill={ props?.fill }
        stroke={ props?.stroke }
        className="speed_handle"
        style={ { offset: `path('${ path }')` } }
      ></circle>
    </svg>
  );
};

SpeedVisual.displayName = 'SpeedVisual';

export default SpeedVisual;
